namespace GeniuzPOS.InitialData {
    export namespace PsDiscCouponTypeItemExtService {
        export const baseUrl = 'InitialData/PsDiscCouponTypeItemExt';

        export declare function Create(request: Serenity.SaveRequest<PsDiscCouponTypeItemExtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsDiscCouponTypeItemExtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsDiscCouponTypeItemExtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsDiscCouponTypeItemExtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsDiscCouponTypeItemExt/Create",
            Update = "InitialData/PsDiscCouponTypeItemExt/Update",
            Delete = "InitialData/PsDiscCouponTypeItemExt/Delete",
            Retrieve = "InitialData/PsDiscCouponTypeItemExt/Retrieve",
            List = "InitialData/PsDiscCouponTypeItemExt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsDiscCouponTypeItemExtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
